import { render, staticRenderFns } from "./OrderableActionDeleteItem.vue?vue&type=template&id=55c94aa1&"
import script from "./OrderableActionDeleteItem.vue?vue&type=script&lang=ts&"
export * from "./OrderableActionDeleteItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports